import { useContext } from "react";
import { PermissionServiceContext } from "./permissionServiceContext";
import type { PermissionService } from "./permissionServiceCore";

export const usePermissionService = (): PermissionService => {
  const ctx = useContext(PermissionServiceContext);
  if (!ctx) {
    throw new Error("usePermissionService must be used within a PermissionProvider");
  }
  return ctx;
};
